

import React, { useState, useRef, useEffect  } from "react"

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  FeatureGroup,
  Polygon,Circle
} from "react-leaflet"

import L, { bounds } from 'leaflet'

import { useLeafletContext } from '@react-leaflet/core'
import "leaflet-draw/dist/leaflet.draw.css"

import "leaflet/dist/leaflet.css"
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
     
const RiskManagementGtPointDetailViewPolygonMap = ({farmerBoundary,MediaData }) => {

  const [center, setCenter] = useState([27.947147057947525, 79.36523437500001])
  const [boundary, setBoundary] = useState([])
  const [showBounds, setBounds] = useState([])
  const [dataPoints, MetadataPoints] = useState([])
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [openLightbox, setOpenLightBox] = useState(false);
  const fillBlueOptions = { fillColor: 'blue' }

  const markerIcon = new L.Icon({
    iconUrl: require("./marker4.jpg"),
    iconSize: [24, 35],
    iconAnchor: [22, 94],
    popupAnchor: [-3, -76],
    shadowSize: [20, 25],
    shadowAnchor: [22, 94]
  })
  


  function getBounds(props) {
    return L.latLng(props.center).toBounds(props.size)
}

function Square(props) {
    const context = useLeafletContext()
    const squareRef = useRef()
    const propsRef = useRef(props)

    useEffect(() => {

        squareRef.current = new L.Rectangle(getBounds(props))
        const container = context.layerContainer || context.map
        container.addLayer(squareRef.current)

        return () => {
            container.removeLayer(squareRef.current)
        }
    }, [])

    useEffect(() => {
        if (
            props.center !== propsRef.current.center ||
            props.size !== propsRef.current.size
        ) {
            squareRef.current.setBounds(getBounds(props))
        }
        if (props?.bounds?.length >= 1){
            context.map.fitBounds(props.bounds)
        }
        propsRef.current = props
        
    }, [props.center, props.size, props?.bounds])

    return null
}
  useEffect(() => {
    if(farmerBoundary){
          setBoundary( farmerBoundary)
  }

  }, [farmerBoundary])

  useEffect(()=>{
    if (boundary)
    {
  
     setBounds(boundary?.coordinates)
    }
   },[boundary])
useEffect(()=>{

  if(MediaData){
    var latlongArray=[]
    var latlongObj={latitude:"",longitude:"",image:""}
     MediaData.map((item,index)=>{
      if(index!=0){
      if(item.Metadata!=="")
      {
        if(item.Metadata.latitude && item.Metadata.longitude)
        {
          latlongObj={latitude:item.Metadata.latitude,longitude:item.Metadata.longitude,image:item.ImagePath}
          latlongArray.push(latlongObj)
        }
      }
    }
     })
     MetadataPoints(latlongArray)
  }
},[MediaData])
const showLargeImage=(image)=>{
  setImageInLightbox(image)
  setOpenLightBox(true)

}

  if (JSON.stringify(boundary) !== `{}`) {
    return (
      <>
      <div className="col">
        <MapContainer center={center} zoom={8} style={{ height: "50vh" }} >/
          <TileLayer
            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          <Square center={center} size={0} bounds={showBounds} />
          <Polygon
            color="red"
            positions={boundary.coordinates}
          />
          {dataPoints.length>0?
            <>
            {dataPoints.map((item,index)=>{
            return(
              <Circle center={[item.latitude,item.longitude]} pathOptions={fillBlueOptions} radius={2.5} >
              <Popup>
              Corner {index +1}
             
             &nbsp; <img src={item.image} width="20px" className="cursor-pointer" onClick={(e) => showLargeImage(item.image)}/>
            </Popup>
            </Circle>
            )
           }
           )}
            </>
       :"" }
       {openLightbox ?
        <Lightbox image={lightBoxViewImage} title="Image Title" onClose={() => setOpenLightBox(false)} />
        : ""}
        </MapContainer>
      </div>
      </>
    )
  }


  return (
    <>
   ""
    </>
  )
}

export default RiskManagementGtPointDetailViewPolygonMap






